import React from 'react';
import AddCommentBox from "../../singlePage/AddCommentBox";

const AddCommentProfile = () => {
    return (
        <div className="add-comment-profile-wrapper">
            <div className="comment-box xpy-8">
                <AddCommentBox/>
            </div>
            <div className="comment-box xpy-8">
                <AddCommentBox/>
            </div>
            <div className="comment-box xpy-8">
                <AddCommentBox/>
            </div>
        </div>
    );
};

export default AddCommentProfile;
